import { connect } from 'react-redux';
import { get } from 'lodash';

import { isUlpBannerVisible } from 'apps/ulp/utils/visibilityRules';
import UlpBanner from '../components/UlpBanner';

export default connect((state) => ({
  display: isUlpBannerVisible({
    isTemporaryHidden: state.ulp.isTemporaryHidden,
    placedOrdersCount: get(state, 'user.shoppingDetails.placedOrdersCount', 0),
    userPreferences: state.userPreferences,
    exclusions: get(state, 'ulp.exclusions', {}),
    currentRoute: state.http.currentRoute,
    previousRoute: state.http.previousRoute,
    referrer: state.http.referrer,
    origin: state.http.origin,
    userHidBanner: get(state, 'ulp.cookies.userHidBanner', false),
  }),
  currentRoute: state.http.currentRoute,
  ulp: state.ulp,
}), undefined, null, { withRef: true })(UlpBanner);
